var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.830078,
    width: 40.4286,
    height: 39,
    rx: 5.5,
    fill: "#FFF8F5",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9368 26.0378H21.0618C23.666 26.0378 24.7077 24.9961 24.7077 22.3919V19.2669C24.7077 16.6628 23.666 15.6211 21.0618 15.6211H17.9368C15.3327 15.6211 14.291 16.6628 14.291 19.2669V22.3919C14.291 24.9961 15.3327 26.0378 17.9368 26.0378Z",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M15.3438 12.4974V10.4141",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.5 12.4974V10.4141",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.666 12.4974V10.4141",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.834 16.6641H29.9173",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.834 20.8301H29.9173",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.834 24.9961H29.9173",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.666 29.1641V31.2474",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.5098 29.1641V31.2474",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M15.3438 29.1641V31.2474",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.08398 16.6641H11.1673",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.08398 20.8301H11.1673",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.08398 24.9961H11.1673",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9993 29.1628H21.9993C26.166 29.1628 27.8327 27.4961 27.8327 23.3294V18.3294C27.8327 14.1628 26.166 12.4961 21.9993 12.4961H16.9993C12.8327 12.4961 11.166 14.1628 11.166 18.3294V23.3294C11.166 27.4961 12.8327 29.1628 16.9993 29.1628Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon1);
export default __webpack_public_path__ + "static/media/feature-icon-1.f34747b47ffa550c3f92593b937859af.svg";
export { ForwardRef as ReactComponent };